import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import PageWipe from './utils/PageWipe';
import ScrollToTop from "./utils/ScrollToTop";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div id="page-wipe" aria-hidden="true" />
      <PageWipe />
      <AppRoutes />
    </BrowserRouter>
  );
}
